module.exports = __webpack_public_path__ + "img/SKC.55c04233.png";